export default __webpack_public_path__ + "static/7-17b9d4a0918b60b298226938ae4127ba.jpg";